import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';

import { CustomerAssessComponent } from './customer-assess/customer-assess';
import { SectionSpecificComponent } from './section-specific/section-specific';
import { CustomerAssessTeamviewComponent } from './customer-assess-teamview/customer-assess-teamview';

@NgModule({
  imports: [SharedModule, CustomerAssessTeamviewComponent, SectionSpecificComponent],
  declarations: [CustomerAssessComponent],
  exports: [CustomerAssessComponent, SectionSpecificComponent, CustomerAssessTeamviewComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AssessmentModule {}
